/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PaginationInfoToJSONTyped,
} from './PaginationInfo';
import type { SponsoredGuildCompetition } from './SponsoredGuildCompetition';
import {
    SponsoredGuildCompetitionFromJSON,
    SponsoredGuildCompetitionFromJSONTyped,
    SponsoredGuildCompetitionToJSON,
    SponsoredGuildCompetitionToJSONTyped,
} from './SponsoredGuildCompetition';

/**
 * 
 * @export
 * @interface GetSponsoredGuildCompetitionsResponse
 */
export interface GetSponsoredGuildCompetitionsResponse {
    /**
     * 
     * @type {PaginationInfo}
     * @memberof GetSponsoredGuildCompetitionsResponse
     */
    paginationInfo: PaginationInfo;
    /**
     * 
     * @type {Array<SponsoredGuildCompetition>}
     * @memberof GetSponsoredGuildCompetitionsResponse
     */
    sponsoredGuildCompetitions: Array<SponsoredGuildCompetition>;
}

/**
 * Check if a given object implements the GetSponsoredGuildCompetitionsResponse interface.
 */
export function instanceOfGetSponsoredGuildCompetitionsResponse(value: object): value is GetSponsoredGuildCompetitionsResponse {
    if (!('paginationInfo' in value) || value['paginationInfo'] === undefined) return false;
    if (!('sponsoredGuildCompetitions' in value) || value['sponsoredGuildCompetitions'] === undefined) return false;
    return true;
}

export function GetSponsoredGuildCompetitionsResponseFromJSON(json: any): GetSponsoredGuildCompetitionsResponse {
    return GetSponsoredGuildCompetitionsResponseFromJSONTyped(json, false);
}

export function GetSponsoredGuildCompetitionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSponsoredGuildCompetitionsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'paginationInfo': PaginationInfoFromJSON(json['paginationInfo']),
        'sponsoredGuildCompetitions': ((json['sponsoredGuildCompetitions'] as Array<any>).map(SponsoredGuildCompetitionFromJSON)),
    };
}

export function GetSponsoredGuildCompetitionsResponseToJSON(json: any): GetSponsoredGuildCompetitionsResponse {
    return GetSponsoredGuildCompetitionsResponseToJSONTyped(json, false);
}

export function GetSponsoredGuildCompetitionsResponseToJSONTyped(value?: GetSponsoredGuildCompetitionsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paginationInfo': PaginationInfoToJSON(value['paginationInfo']),
        'sponsoredGuildCompetitions': ((value['sponsoredGuildCompetitions'] as Array<any>).map(SponsoredGuildCompetitionToJSON)),
    };
}

